import {DropdownSelect, DropdownSelectText} from "@reside/ui";
import {WorkflowFilter} from "./utils/types";

export const WorkflowFilterDropdown = ({
  workflowFilter,
  onWorkflowFilterSelect,
  workflowFilterOptions,
}: {
  workflowFilter: WorkflowFilter;
  onWorkflowFilterSelect: (item: WorkflowFilter) => void;
  workflowFilterOptions: ReadonlyArray<WorkflowFilter>;
}) => (
  <DropdownSelect
    trigger={({isOpened}) => (
      <DropdownSelectText isOpened={isOpened} label={workflowFilter.label} />
    )}
    selectItem={onWorkflowFilterSelect}
    selectedItem={workflowFilter}
    items={workflowFilterOptions as WorkflowFilter[]}
    label="Workflow"
  />
);
